<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-button @click="searchQuery" type="primary">刷新</a-button>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- table区域-begin -->
    <div  class="margin-top-20px"  >
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
      </a-table>
    </div>

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction } from '@/api/manage'
  export default {
    name: "BusDailyProjectUserHistory",
    mixins:[JeecgListMixin],
    props:{
      projectRecords:{
        type:Array,
        default:[]
      },
    },
    data () {
      return {
        description: '项目人员修改记录表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'成员',
            align:"center",
            dataIndex: 'members'
          },
          {
            title:'角色',
            align:"center",
            dataIndex: 'subordinateRole'
          },
          {
            title:'工作量占比',
            align:"center",
            dataIndex: 'workload'
          },
          {
            title:'开始时间',
            align:"center",
            dataIndex: 'startTime',
          },
          {
            title:'结束时间',
            align:"center",
            dataIndex: 'endTime',
          },
        ],
        url: {
          list: "/dailyproject/busDailyProjectUserHistory/list",
          delete: "/dailyproject/busDailyProjectUserHistory/delete",
          deleteBatch: "/dailyproject/busDailyProjectUserHistory/deleteBatch",
          exportXlsUrl: "/dailyproject/busDailyProjectUserHistory/exportXls",
          importExcelUrl: "dailyproject/busDailyProjectUserHistory/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initData(){
        this.loadData()
      },
      loadData(arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams() //查询条件
        params.projectId=this.projectRecords[0].id
        this.loading = true
        this.dataSource = []
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
            this.pageRefresh++
          } else {
            this.$message.warning(res.message)
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false
        })
      },
    },
    watch:{
      projectRecords:{
        handler(){
          this.loadData(1)
        },
        immediate:true,
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>